<template>
    <div class="i-post">
        <div class="post" v-if="currentPost" @click="openContent">
            <div v-if="!currentPost.content[lang].text">
                <div class="container">
                    <div class="div" style="font-size:32px;text-align:center;padding:140px 0;">
                        {{tr.sorry_not_available}}
                    </div>
                </div>
            </div>
            <div class="container post-content-container" v-if="currentPost.content[lang].text" @click="openContent">
                <div class="row no-gutters">
                    <div class="col-12 col-md-9 post-content" v-html="currentPost.content[lang].text.toHTML()"></div>
                    <div class="d-xs-none col-md-3">
                        <slot/>
                    </div>
                </div>
                <!-- <p v-if='currentPost.source' style='text-align:right'>{{tr.source}}: 
				<a :href="currentPost.source" target="_blank" >{{url(currentPost.source).get('hostname')}}</a>
			</p> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {

    name: 'i-post',

    name: 'post-view',
    methods: {
        loadSeo() {
            let self = this;
            setTimeout(() => {
                _i.seo.load(self.seo);
            }, 100);
            setTimeout(() => {
                _i.seo.load(self.seo);
            }, 1000);
        },
        url: _i.url,
        openPost(post) {
            //this.$store.commit('viewPost',post);
            location.href = "#/posts/" + post._id + '#header';
        },
        openContent(e) {
            //console.log(e)

            let self = this;
            console.log(e)
            document.getElementById("main-view").addEventListener('click', (e) => {
                //console.log("CLICK",e);
                //alert(1);
                //e.preventDefault();
                console.log(e)
                //e.preventDefault();
                if (e.target.tagName == "A") {
                    console.log(e);
                    e.trigger('click');

                }

                if (e.target.tagName == "IMG") {
                    //e.preventDefault();
                    let postContent = document.getElementsByClassName("post-content")[0];
                    var all_img = postContent.getElementsByTagName('img');
                    console.log(all_img, postContent);
                    let list = [];
                    for (let i = 0; i < all_img.length; i++) {
                        let img = all_img[i];
                        list.push({ src: img.src, title: img.title, "date": "2018-06-25T03:17:22.000Z", "description": "" });
                    }
                    console.log(list)
                    let foundIndex = list.findIndex((i) => {
                        if (i.src === e.target.src) return true;
                        else return false;
                    });

                    self.$store.commit('openPhoto', { list, index: foundIndex ? foundIndex : 0 });
                }
            });
        }
    },
    computed: {
        seo() {
            if (!this.currentPost) return { title: {} };
            let { content, preview } = this.currentPost;
            return Object.keys(content).reduce((ns, lang) => {
                ns.image = preview;
                ns.title[lang] = content[lang].title;
                ns.description[lang] = content[lang].short;
                return ns;
            }, { title: {}, description: {} });
        },
        currentPost() {
            let { id } = this.$route.params;
            let found = this.posts.find(p => { return p._id === id });
            if (found) return found;
            else {
                this.$store.dispatch('loadPost', id);
                this.loadSeo();
            }
        },
        currentPostLite() {
            let { id } = this.$route.params;
            let found = this.$store.state.posts.list.find(p => { return p._id === id });
            if (found) return found;
        },
        pubs() {
            let { lang } = this;
            let { id } = this.$route.params;
            return this.$store.state.posts.list.filter(p => { return p.content[lang] && p.content[lang].enabled }).filter((p) => { return p._id != id }).slice(0, 6);
        },
        posts() { return this.$store.state.posts.full; }
    },
    mounted() {
        document.documentElement.scrollTop = 0;
        console.log(this.$route)
    }
}
</script>
<style lang="css" scoped>

.post {
    /*position: fixed;*/		
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 8;
    background: white;
    /*overflow-y: scroll;*/

}

.post>div {}

.post .post-content-container {
    padding-top: 60px;
    padding-bottom: 120px;
}

.post-content {
    /*max-width: 820px;*/
    border-left: 1px solid grey;
    padding-left: 24px;
    white-space: pre-line;
}

@media(max-width:768px) {
    .post-content {
        border-left: none;
        padding: 0;
        padding: 0 12px;
    }

    .last-publications {
        margin-left: auto;
    }

    h3.pub-title {
        padding-left: 0;
        font-size: 26px;
    }

    .post .title {
        font-size: 22px;
    }

    .pub {
        max-width: 90%;
        margin: 0 auto 32px auto;
    }
}
</style>
<style>
.post-content a {
    text-decoration: none;
}

.post-content img {
    max-width: 100%;
    /*margin:18px 24px !important;*/
    display: block !important;
    text-align: middle;
    border: 2px solid white;
    box-shadow: 1px 1px 8px grey;
    height: auto;
    /*margin-left:-80px;*/
}

.post-content iframe {
    max-width: 100%;

}

.post-content,
.post-content * {
    /*font-family: "Times New Roman", serif !important;*/
    font-family: 'Merriweather', serif;
    font-size: 18px;
    line-height: 1.5;
    text-align: justify;
}

.pub {
    margin: 0 0 22px 0px;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
}

.pub img {
    max-width: 100%;
}

.last-publications {
    margin-left: 42px;
}


.post-content-container {
    padding: 60px 0;
}

h3.pub-title {
    padding-left: 43px;
}
</style>